import { ContractSuspendAPI } from "../api";
import i18n from '@/plugins/vue-i18n';

export class ContractSuspend {
    constructor(props) {
        for (const [key, value] of Object.entries(props)) {
            this[key] = value;
        }

        let suspendTypeLabel = {
            "temporary": i18n.t('suspend.type.temporary'),
            "late": i18n.t('suspend.type.late'),
            "leave": i18n.t('suspend.type.leave'),
            "warn_1": i18n.t('suspend.type.warn_1'),
            "warn_2": i18n.t('suspend.type.warn_2'),
            "warn_3": i18n.t('suspend.type.warn_3'),
            "other": i18n.t('suspend.type.other')
        }

        this.typeText = suspendTypeLabel[this.type] || '-'
        if (this.otherType && this.type == "other") {
            this.typeText = `${this.typeText} [${this.otherType}]`
        }
    }
    static async getContractSuspendByContract(payload) {
        const { data } = await ContractSuspendAPI.getContractSuspendByContract(payload);
        data.result.map(item => new ContractSuspend(item));
        return data.result;
    }
    static async createContractSuspend(payload) {
        const { data } = await ContractSuspendAPI.createContractSuspend(payload);
        // Array Return
        //   data.result.map((item) => new ContractSuspend(item));
        // Object Return
        data.result = new ContractSuspend(data.result)
        return data.result;
    }
    static async getContractSuspend(payload) {
        const { data } = await ContractSuspendAPI.getContractSuspend(payload);
        // Array Return
        //   data.result.map((item) => new ContractSuspend(item));
        // Object Return
        data.result = new ContractSuspend(data.result)
        return data.result;
    }
    static async editContractSuspend(payload) {
        const { data } = await ContractSuspendAPI.editContractSuspend(payload);
        // Array Return
        //   data.result.map((item) => new ContractSuspend(item));
        // Object Return
        data.result = new ContractSuspend(data.result)
        return data.result;
    }
    static async removeContractSuspend(payload) {
        const { data } = await ContractSuspendAPI.removeContractSuspend(payload);
        // Array Return
        //   data.result.map((item) => new ContractSuspend(item));
        // Object Return
        data.result = new ContractSuspend(data.result)
        return data.result;
    }
    static async removedContractSuspend(payload) {
        const { data } = await ContractSuspendAPI.removedContractSuspend(payload);
        data.result = new ContractSuspend(data.result)
        return data.result;
    }
    static async getContractSuspendBetweenDateByMarket(payload) {
        const { data } = await ContractSuspendAPI.getContractSuspendBetweenDateByMarket(payload);
        return data.result.map(item => new ContractSuspend(item));
    }
}